import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { NotifierService } from 'angular-notifier';
import { CancelModal } from 'src/app/shared/modals/cancel/cancel-modal.component';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { CompanyPartnerDto } from 'src/app/domain/models/dto/company-partner.dto';
import { CompanyResponsibleDto } from 'src/app/domain/models/dto/company-responsible.dto';
import { AuthenticationService } from 'src/app/shared/services';

import { RegisterService } from '../../../../shared/services/register.service';
import { CompanyPartnerService } from 'src/app/shared/services/company-partner.service';
import { CompanyResponsibleService } from 'src/app/shared/services/company-responsible.service';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { RegisterStepType } from 'src/app/domain/enums/register-step-types.enum';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: [],
})
export class DocumentsComponent implements OnInit {
  private readonly notifier: NotifierService;
  tenant: string = '';
  public loading: boolean;
  corporateAccount: CorporateAccountDto;
  balanceSent: boolean = false;
  residenceSent: boolean = false;

  get companyId() {
    return +this.authService.getCompanyId();
  }

  constructor(
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly modalService: BoobleModalService,
    private readonly companyResponsibleService: CompanyResponsibleService,
    private readonly companyPartnerService: CompanyPartnerService,
    private readonly corporateAccountService: CorporateAccountService,
    private readonly registerService: RegisterService,
    private readonly authService: AuthenticationService
  ) {
    this.notifier = notifierService;
  }

  fetchCorporateAccount() {
    return this.corporateAccountService
      .get()
      .pipe(take(1))
      .subscribe((cpa) => {
        this.corporateAccount = cpa.data;
        if(cpa.data.residentialProof) {
          this.residenceSent = true;
        };
        if(cpa.data.balanceDRERevenue) {
          this.balanceSent = true;
        }
      });
  }

  async uploadBalanceFile(companyId: number, event: any) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.corporateAccountService
        .uploadBalanceFile(companyId, fileList.item(0))
        .subscribe((uploadResult) => {
          this.balanceSent = true;
          this.notifier.notify(
            'success',
            'Balanço/DRE/Faturamento enviado com sucesso!'
          );
        });
    }
  }

  async uploadResidenceFile(companyId: number, event: any) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.corporateAccountService
        .uploadResidenceFile(companyId, fileList.item(0))
        .subscribe((uploadResult) => {
          this.residenceSent = true;
          this.notifier.notify(
            'success',
            'Comprovante de residência enviado com sucesso!'
          );
        });
    }
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });

    this.fetchCorporateAccount();
  }

  goNext() {
    this.loading = true;
    this.registerService
      .putRegisterStep(RegisterStepType.CompanyDocuments)
      .subscribe({
        next: (stepResult) => {
          this.loading = false;
          this.router.navigate([
            `${this.tenant}/onboardings/register-confirmation`,
          ]);
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  goPrevious() {
    this.router.navigate([`${this.tenant}/onboardings/second-limit`]);
  }

  openCancelModal() {
    this.modalService.present(CancelModal);
  }
}
